import { setFarmChatResults, setIsloading } from "../features/chatbotSlice";
import {
    createApi,
    fetchBaseQuery
  } from "@reduxjs/toolkit/query/react";

const APIM_SUBSCRIPTION_VALUE = process.env.REACT_APP_FARM_CHATBOT_APIM_SUBSCRIPTION_VALUE
const BASE_URL = process.env.REACT_APP_FARM_CHATBOT_API_URL

export interface ChatbotQueryParam {
    email: string,
    query: string
}

export interface StringMap {
    [key: string]: string
}

export interface ChatbotResultType {
    data: StringMap[],
    error: any,
    isLoading: boolean
}

export const chatApi = createApi({
    reducerPath: "chatApi",
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        prepareHeaders: async (headers, { getState }) => {
            headers.set('Content-Type', `application/json`)
            headers.set('Ocp-Apim-Subscription-Key', `${APIM_SUBSCRIPTION_VALUE}`)
            // headers.set('Authorization', `Bearer ${state.auth.idToken}`)
            return headers
        }
    }),
    tagTypes: ["Chat"],
    endpoints: (builder) => ({
        fetch: builder.query({
            query: (query: ChatbotQueryParam) => ({
                url: `/data`,
                method: 'GET',
                query
            })
        }),
        // farm api endpoint
        getAnswers: builder.mutation({
            query: (body: ChatbotQueryParam) => ({
                url: `/data`,
                method: 'POST',
                body
            }),
            async onQueryStarted({ query }, { dispatch, getState, queryFulfilled }) {
                dispatch(setIsloading(true))
                try {
                    const { data } = await queryFulfilled
                    dispatch( setFarmChatResults({ query, answer: data }) )
                } catch (err) {
                }
                dispatch(setIsloading(false))
              }
        }),
        })
    })
    
export const {
    useFetchQuery, useGetAnswersMutation
  } = chatApi;